import { getUserEmail } from '../shared/utils';
import { containersApi } from './api';

const baseRoute = '/service-provider';

export const ServiceProviderApi = {
  saveServiceProviderWithContact: (serviceProvider) => {
    return containersApi.post(`${baseRoute}`, serviceProvider);
  },
  serviceProviderWithContactOptions: ({ searchTerm, showDeleted }) => {
    return containersApi.get(
      `${baseRoute}/serviceProviderWithContactOptions?searchTerm=${searchTerm}&deleted=${
        showDeleted ? 'true' : 'false'
      }`
    );
  },
  //Following endpoints can disable and reenable serviceProvider or serviceLevel
  setDeleteFlagServiceProvider: (serviceProviderId, deleteFlag) => {
    return containersApi.put(`${baseRoute}/${serviceProviderId}`, {
      deleteFlag: deleteFlag,
    });
  },
  setDeleteFlagServiceLevel: (
    serviceProviderId,
    serviceLevelId,
    deleteFlag
  ) => {
    return containersApi.put(
      `${baseRoute}/${serviceProviderId}/service-level/${serviceLevelId}`,
      { deleteFlag: deleteFlag }
    );
  },
};
